module.exports = __webpack_public_path__ + "static/media/homepage_atf_4_mo_en.deeefdc9.png";